 
 
 export enum ExecutionHistoryReloadActionType {
    AnalysisWizard,
    AdvancedAnalysisWizard
  }